const HydrologyTypes = {
  UPDATE_SELECTED_TAB: 'UPDATE_SELECTED_TAB',
  UPDATE_HOVERED_GAUGE: 'UPDATE_HOVERED_GAUGE',
};

export default HydrologyTypes;



// WEBPACK FOOTER //
// ./src/action-types/hydrology.js